import { IGroup } from "@grassrootly/api";
import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";

export interface CreateGroupPlayer {
  create_group_player: { [key: string]: IGroup };
}

const initialState: CreateGroupPlayer = {
  create_group_player: {},
};

const createGroupPlayerSlice = initReducer({
  name: "create-group-player",
  initialState,
  reducers: {
    setCreateGroupPlayer: (state: CreateGroupPlayer, action: PayloadAction<IGroup[]>) => {
      action.payload.forEach((groupPlayer) => {
        state.create_group_player[groupPlayer.id] = groupPlayer;
      });
    },
    cleanState: () => {
      return initialState;
    },
  },
});

const persistConfig: PersistConfig<CreateGroupPlayer> = {
  key: "create-group-player",
  storage: AsyncStorage,
};

export const createGroupPlayerActions = createGroupPlayerSlice.actions;

export default createPersistReducer(persistConfig, createGroupPlayerSlice.reducer);
